import styled, { useTheme } from "styled-components";
import { Oval } from "react-loader-spinner";
import { BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX } from "../../constants";
import { ContentContainer, StyledScreen } from "../styles";

const ScreenLoading = styled.div`
  display: grid;
  justify-content: center;
  align-content: center;
  height: 100%;
`;

const ScreenLoader = () => {
  const theme = useTheme();
  return (
    <StyledScreen>
      <ContentContainer>
        <ScreenLoading>
          <Oval
            height={50}
            width={50}
            color={theme.colors.action.primary}
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor={`${theme.colors.action.primary}${BUTTON_HIGHLIGHT_HEX_OPACITY_SUFFIX}`}
            strokeWidth={4}
            strokeWidthSecondary={4}
          />
        </ScreenLoading>
      </ContentContainer>
    </StyledScreen>
  );
};

export { ScreenLoader };
